import SearchIcon from "@mui/icons-material/Search";
import { addDays, isAfter, isBefore, parseISO, subDays } from "date-fns";
import { motion } from "framer-motion";
import { useContext, useEffect, useState } from "react";
import { Alert, Button, InputGroup } from "react-bootstrap";
import { useForm } from "react-hook-form";
import useActas from "../../../api/actas";
import { ContainerScreenGeneral, MuniSpinner2, Table } from "../../../components";
import ExcelButton from "../../../components/ExcelButton";
import { UserContext } from "../../../context";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import { useActasStore } from "../../../store/actasStore";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import ModalsOpcionesActas from "../../../views/modals";
import ActaDetalle from "../ActaDetalle";
import { tableData } from "./tableData";
import DetalleDeActa from "../../../components/DetalleDeActa";
import BadgeEstados from "../../../components/BadgeEstado";
import Table2 from "../../../components/Table2";

const BuscarActa = () => {
  const { actions: ua } = useContext(UserContext);
  const { modals } = useGeneralAppStore();
  const { estadoBuscado, setEstadoBuscado } = useActasStore()

  // const { register, handleSubmit, watch } = useForm()

  const { buscarActa } = useActas();

  const [tab, setTab] = useState(1);
  const handleChange = (event, value) => {
    setTab(value);
  };


  const headers = [
    { label: "ID", key: "id" },
    { label: "#Acta", key: "numero_infraccion" },
    { label: "Infraccion", key: "tipo" },
    { label: "Patente", key: "plate" },
    { label: "Localidad", key: "localidad" },
    { label: "Documento", key: "documento_titular" },
  ];

  const {
    actas,
    setActasFilter,
    codigosZonales,
    codigosForaneos,
    setActaDetalle,
    actasBuscadas,
    setActasBuscadas,
  } = useActasStore();
  const { actaDetalle, cleanStore } = useActaDetalleStore();

  const { loads, handlerModal } = useGeneralAppStore();
  const [buscar, setBuscar] = useState(false);
  const [busqueda, setBusqueda] = useState();

  const [filtros, setFiltros] = useState({
    tipo: "",
    localidad: "",
    fecha_desde: "",
    fecha_hasta: "",
    codigo_postal: "",
    zonales: "",
    search: "",
  });

  const onSubmit = (data) => {
    buscarActa(data);
    setBuscar(true);
  };

  useEffect(() => {
    return () => {
      setActaDetalle(null);
      setActasBuscadas([]);
    };
  }, []);

  useEffect(() => {
    const actasFiltrados = actas?.filter((acta) => {
      let isInRage = true;
      const fecha = parseISO(acta.fecha_hora.split(" ")[0].split("/").reverse().join("-"));
      const fechaDesde = parseISO(filtros.fecha_desde);
      const fechaHasta = parseISO(filtros.fecha_hasta);
      const ajustarFechaDesde = subDays(fechaDesde, 1);
      const ajustarFechaHasta = addDays(fechaHasta, 1);
      if (filtros.fecha_desde != "" && filtros.fecha_hasta != "") {
        isInRage = isAfter(fecha, ajustarFechaDesde) && isBefore(fecha, ajustarFechaHasta);
      }

      if (filtros.fecha_desde != "" && filtros.fecha_hasta == "") {
        isInRage = isAfter(fecha, ajustarFechaDesde);
      }

      if (filtros.fecha_desde == "" && filtros.fecha_hasta != "") {
        isInRage = isBefore(fecha, ajustarFechaHasta);
      }

      let pepe = codigosForaneos;
      if (filtros.zonales != "" && filtros.zonales == "zonales") {
        pepe = codigosZonales;
      }

      if (
        (filtros.zonales != "" ? pepe.includes(acta.codigo_postal) : true) &&
        acta.tipo?.includes(filtros.tipo) &&
        isInRage &&
        (acta.plate?.toLowerCase().includes(filtros.search.toLowerCase()) ||
          acta?.numero_acta?.toString().toLowerCase().includes(filtros.search.toLowerCase()) ||
          acta?.documento_titular?.toString().toLowerCase().includes(filtros.search.toLowerCase()))
      ) {
        return acta;
      }
    });
    setActasFilter(actasFiltrados);
  }, [filtros]);

  const {
    register,
    watch,
    handleSubmit,
    resetField,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: "all",
    defaultValues: {
      datos_sobre: "numero_acta",
      valor: "",
    },
  });

  useEffect(() => {
    resetField("valor");

    return () => {
      cleanStore();
    };
  }, [watch("datos_sobre")]);

  const datosSobrePatente = watch("datos_sobre")?.trim().toUpperCase() === "PLATE";

  // console.log(busqueda)
  // console.log(watch())

  return (
    <ContainerScreenGeneral titulo={"Buscador de actas"} linkBack={"/"} size={"full"}>
      {loads.includes("actas") ? (
        //  || loads.includes("notificadores")
        <MuniSpinner2 />
      ) : (
        <>
          <form
            className="py-4"
            onSubmit={handleSubmit((data) => {
              buscarActa(data);
              setBusqueda(data.datos_sobre);
              // setEstadoBuscado(null)
              setBuscar(true);

            })}
          >

            <fieldset className="d-flex flex-column gap-3" disabled={isSubmitting}>
              <div className="col-12 mx-auto d-flex justify-content-center">
                <div className="d-flex flex-column  flex-sm-row align-items-sm-center gap-2 gap-sm-4 cursor-pointer">
                  <div className="d-flex gap-2">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="input-dominio"
                      value={"numero_acta"}
                      {...register("datos_sobre")}
                    />
                    <label
                      htmlFor="input-dominio"
                      className="label-busqueda-dominio"
                      style={{ marginTop: "2px" }}
                    >
                      Por número de infracción
                    </label>
                  </div>
                  <div className="d-flex gap-2">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="input-patente"
                      value={"plate"}
                      {...register("datos_sobre")}
                    />
                    <label
                      htmlFor="input-patente"
                      className="label-busqueda-dominio"
                      style={{ marginTop: "2px" }}
                    >
                      Por patente
                    </label>
                  </div>
                  <div className="d-flex gap-2">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="input-documento"
                      value={"documento"}
                      {...register("datos_sobre")}
                    />
                    <label
                      htmlFor="input-documento"
                      className="label-busqueda-dominio"
                      style={{ marginTop: "2px" }}
                    >
                      Por documento
                    </label>
                  </div>
                  <div className="d-flex gap-2">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="input-estado"
                      value={"estado"}
                      {...register("datos_sobre")}
                    />
                    <label
                      htmlFor="input-estado"
                      className="label-busqueda-dominio"
                      style={{ marginTop: "2px" }}
                    >
                      Estado
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-10 col-sm-6 col-md-5 col-lg-3 mx-auto">
                {/* <label htmlFor="valor">
                                        {datosSobreDominio ? "Dominio *" : "Documento / CUIT *"}
                                    </label> */}

                {/* <Form className="col-4 mx-auto" onSubmit={handleSubmit(onSubmit)}>
                            <Form.Group>
                                <InputGroup>
                                    <Form.Control type="number" {...register('numero_infraccion')} />
                                    <Button
                                        disabled={watch('numero_infraccion') == ""}
                                        type="submit">
                                        <SearchIcon />
                                    </Button>
                                </InputGroup>
                            </Form.Group>
                        </Form> */}
                <InputGroup>
                  <input
                    id="valor"
                    className={
                      "form-control mb-0" + (errors["valor"] ? " border border-danger " : "")
                    }
                    {...register("valor")}
                    type={datosSobrePatente ? "text" : "number"}
                    maxLength={datosSobrePatente ? 7 : 11}
                    onInput={(e) => {
                      if (e.target.value.length > e.target.maxLength) {
                        e.target.value = e.target.value.substring(0, 11);
                        return false;
                      }

                      return true;
                    }}
                    onKeyDown={(e) => {
                      if (datosSobrePatente) return true;

                      const teclasNoPermitidas = [
                        "KeyE",
                        "ArrowUp",
                        "ArrowDown",
                        "Minus",
                        "Plus",
                        "Equal",
                        "Comma",
                        "Period",
                        "Space",
                      ];
                      const noEsTeclaPermitida = teclasNoPermitidas.includes(e.code);
                      if (noEsTeclaPermitida) {
                        e.stopPropagation();
                        e.preventDefault();
                        return false;
                      }

                      return true;
                    }}
                  />
                  {errors["valor"] && (
                    <small className="fw-semibold text-danger mb-0 mt-2 d-block">
                      {errors["valor"]?.message}
                    </small>
                  )}
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    size="lg"
                    className="d-flex justify-content-center "
                  >
                    {isSubmitting ? (
                      <span className="d-flex align-items-center gap-1">
                        <MuniSpinner2
                          width="18px"
                          height="18px"
                          circularProgressSize={24}
                          circularProgressColor="#ffffff"
                          fileName="bola-blanca.png"
                        />
                      </span>
                    ) : (
                      <SearchIcon />
                    )}
                  </Button>
                </InputGroup>
              </div>
            </fieldset>
          </form>

          <div className="py-3 position-relative">
            {buscar && busqueda == "numero_acta" && (
              <motion.div
                initial={{ minHeight: 0, opacity: 0 }}
                animate={{ minHeight: buscar ? "560px" : 0, opacity: buscar ? 1 : 0 }}
                transition={{ duration: 1 }}
                style={{ overflow: "hidden" }}
              >
                {loads.includes("buscar_acta") || loads.includes("acta_detalle") ? (
                  <div className="w-100 h-100 d-flex justify-content-center align-items-start py-5">
                    <div className="my-5 py-5">
                      <MuniSpinner2 />
                    </div>
                  </div>
                ) : (
                  <>
                    {actaDetalle ? (
                      <DetalleDeActa />
                      // <ActaDetalle />
                    ) : (
                      <section className="col-10 mx-auto py-5 d-flex justify-content-center">
                        <hr />
                        <Alert variant="danger" style={{ width: "fit-content" }}>
                          No existe el acta con el número de infracción ingresado
                        </Alert>
                      </section>
                    )}
                  </>
                )}
              </motion.div>
            )}

            {buscar && (busqueda == "plate" || busqueda == "documento") && (
              <motion.div
                initial={{ minHeight: 0, opacity: 0 }}
                animate={{ minHeight: buscar ? "560px" : 0, opacity: buscar ? 1 : 0 }}
                transition={{ duration: 1 }}
                style={{ overflow: "hidden" }}
              >
                {loads.includes("buscar_acta") || loads.includes("acta_detalle") ? (
                  <div className="w-100 h-100 d-flex justify-content-center align-items-start py-5">
                    <div className="my-5 py-5">
                      <MuniSpinner2 />
                    </div>
                  </div>
                ) : (
                  <>
                    {actas && (busqueda == "plate" || busqueda == "documento") && (
                      <Table2
                        height={"60vh"}
                        data={tableData(actas)}
                        name="actas"
                        maxHeight="70vh"
                        search
                        paginationModel={null}
                        excel={() => (
                          <ExcelButton
                            filterFields={busqueda == 'plate' ? { plate: watch('valor') } : { documento_titular: watch('valor') }}
                            headers={headers}
                            data={actas}
                            filename={"listado-actas.csv"}
                          />
                        )}
                        sx={{
                          ".MuiDataGrid-row.Mui-selected": {
                            backgroundColor: "transparent",
                          },
                          ".MuiDataGrid-row.asignado": {
                            backgroundColor: "#1F42D7",
                            color: "white",
                          },
                          ".MuiDataGrid-row.tieneDomicilio": {
                            backgroundColor: "#198754",
                            color: "white",
                          },
                        }}
                      />
                    )}
                  </>
                )}
              </motion.div>
            )}
            {buscar && (busqueda == "estado") &&
              <div className="d-flex justify-content-center flex-column align-items-center position-relative">
                {
                  (loads.includes("buscar_acta") || loads.includes("acta_detalle")) ? (
                    <div className="w-100 h-100 d-flex justify-content-center align-items-start py-5">
                      <div className="my-5 py-5">
                        <MuniSpinner2 />
                      </div>
                    </div>
                  )
                    :
                    <div className="d-flex justify-content-center flex-column align-items-center position-relative">
                      <p className="fw-bold text-primary fs-4 m-0">Estado</p>
                      <BadgeEstados estado_id={estadoBuscado} size={'lg'} />
                    </div>
                }
              </div>
            }
          </div>
        </>
      )}
      {/* {(ua.hasRole('tribunales') && modals.includes('descargo')) ? (
                <ModalDescargo modals={modals} handlerModal={handlerModal} actaDetalle={actaDetalle} />
            ) : null}
            <ModalActaDetalle type={'acta_incompleta'} />
            <ModalMarcarImpresa /> */}
      <ModalsOpcionesActas />
    </ContainerScreenGeneral>
  );
};
export default BuscarActa;
